import React from 'react';
import PropTypes from 'prop-types';
import loadable from '@loadable/component';
import { LoadableFallback } from 'components/Common/LoadableFallback';

const CurrentStatus = loadable(() => import(/* webpackChunkName: "ComingSoon" */ './CurrentStatus'), {
  fallback: <LoadableFallback visible />,
});

const asyncCurrentStatus = ({ route }) => (
  <CurrentStatus route={route} />
);

asyncCurrentStatus.propTypes = {
  route: PropTypes.object.isRequired,
};

export default asyncCurrentStatus;
